/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_difference_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does the order of the two numbers matter?`)
};

const es_pct_difference_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Importa el orden de los dos números?`)
};

const de_pct_difference_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielt die Reihenfolge der beiden Zahlen eine Rolle?`)
};

const nl_pct_difference_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maakt de volgorde van de twee getallen uit?`)
};

const fr_pct_difference_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'ordre des deux nombres a-t-il de l'importance ?`)
};

const it_pct_difference_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'ordine dei due numeri è importante?`)
};

const pt_br2_pct_difference_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A ordem dos dois números importa?`)
};

const pt_pct_difference_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A ordem dos dois números importa?`)
};

const ja_pct_difference_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つの数値の順序は結果に影響しますか？`)
};

const zh_pct_difference_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两个数字的顺序重要吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_difference_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_difference_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_difference_faq2_q", locale)
	if (locale === "en") return en_pct_difference_faq2_q(inputs)
	if (locale === "es") return es_pct_difference_faq2_q(inputs)
	if (locale === "de") return de_pct_difference_faq2_q(inputs)
	if (locale === "nl") return nl_pct_difference_faq2_q(inputs)
	if (locale === "fr") return fr_pct_difference_faq2_q(inputs)
	if (locale === "it") return it_pct_difference_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_difference_faq2_q(inputs)
	if (locale === "pt") return pt_pct_difference_faq2_q(inputs)
	if (locale === "ja") return ja_pct_difference_faq2_q(inputs)
	return zh_pct_difference_faq2_q(inputs)
};